import { useRouterExt } from "./useRouterExt";
import { useTeamConfig } from "../components/TeamConfigProvider";
import { useApiRoutes } from "./useApiRoutes";
import { useSSAuth } from "./useSSAuth";
import { global_config } from "src/shared/global_config";
import { TLogoutRedirectRoute } from "./useLogout";
import { TOAuthState } from "src/shared/types/globalStotre.types";

export function useTicketmaster() {
  const { FRONTEND_URL } = global_config;
  const { TEAM_SCHEMA, CLIENT_ID } = useTeamConfig();
  const redirectUri = `${FRONTEND_URL}/tmcallback/${TEAM_SCHEMA}`;

  // apis
  const { getTmAuthUrlApi } = useApiRoutes();
  const { loginToSs } = useSSAuth();

  const connectTicketmaster = async ({ state }: { state?: TOAuthState }) => {
    try {
      const { authURL: tmAuthURL } = await getTmAuthUrlApi.get();
      state = state || {};
      state.teamSchema = TEAM_SCHEMA;
      let stateStr = window.btoa(JSON.stringify(state)).replaceAll("=", "");
      let finalTmAuthURL = tmAuthURL
        .replace("REDIRECT_URL", redirectUri)
        .replace("STATE", stateStr);
      window.location.href = finalTmAuthURL;
    } catch (error) {
      console.log(error);
    }
  };

  const handleTmAuthRedirect = async () => {
    await loginToSs();
  };

  const logoutTicketmaster = async (redirectRoute: TLogoutRedirectRoute) => {
    const redirectPath = redirectRoute.replace("[teamSchema]", TEAM_SCHEMA); // converting to actual path string
    const redirectUrl = `${FRONTEND_URL}/${redirectPath}`;

    let finalLogoutRedirectUrl = `${FRONTEND_URL}/tmcallback/${TEAM_SCHEMA}?logoutRedirectUrl=${redirectUrl}`;
    const tmUrl = `https://auth.ticketmaster.com/sign-out?clientId=${CLIENT_ID}&redirectUrl=${encodeURIComponent(
      finalLogoutRedirectUrl
    )}`;
    window.open(tmUrl, "_self");
  };

  return {
    connectTicketmaster,
    handleTmAuthRedirect,
    logoutTicketmaster,
    redirectUri,
  };
}
